<article class="summary-modal">
  <div class="sheet-handle"></div>
  <header>
    <div>
      <span class="summary-modal__eyebrow">
        @if (summary.group) {
          {{ summary.group.shield || "🏆" }} {{ summary.group.name }}
        } @else {
          Clasificación general
        }
      </span>
      <h1>
        {{ summary.data?.narrative?.headline || summary.title }}
      </h1>
      <p>{{ summary.title }}</p>
    </div>
    <button mat-icon-button type="button" (click)="close()" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="summary-modal__content">
    @if (summary.data?.narrative; as narrative) {
      <section class="chronicle">
        <p>{{ narrative.intro }}</p>
        <h2>Lo más destacado de la jornada</h2>
        <ul>
          @for (highlight of narrative.highlights; track highlight) {
            <li>{{ highlight }}</li>
          }
        </ul>
        @if (narrative.overallConclusions?.length) {
          <h2>Conclusiones de la clasificación general</h2>
          <ul>
            @for (
              conclusion of narrative.overallConclusions;
              track conclusion
            ) {
              <li>{{ conclusion }}</li>
            }
          </ul>
        }
        @if (narrative.playfulSetbacks?.length) {
          <h2>La porra también tiene días de barro</h2>
          <ul>
            @for (setback of narrative.playfulSetbacks; track setback) {
              <li>{{ setback }}</li>
            }
          </ul>
        }
        <p>{{ narrative.closing }}</p>
      </section>
    }

    @if (summary.data?.overallStandings?.length) {
      <section>
        <h2>Clasificación acumulada</h2>
        <div class="ranking ranking--overall">
          @for (
            entry of summary.data?.overallStandings;
            track entry.userId
          ) {
            <div>
              <b>{{ entry.pos }}º</b>
              <strong>{{ entry.userName }}</strong>
              <span>
                {{ entry.points }} pts
                @if (entry.gapToLeader > 0) {
                  · a {{ entry.gapToLeader }}
                }
              </span>
            </div>
          }
        </div>
      </section>
    }

    @if (summary.data?.topMovers?.length) {
      <section>
        <h2>Clasificación de la jornada</h2>
        <div class="ranking">
          @for (entry of summary.data?.topMovers; track entry.userId) {
            <div>
              <b>{{ entry.pos }}º</b>
              <strong>{{ entry.userName }}</strong>
              <span>{{ entry.roundPoints }} pts</span>
            </div>
          }
        </div>
      </section>
    }

    @if (summary.data?.snipers?.length) {
      <section>
        <h2>Dianas</h2>
        <div class="chips">
          @for (sniper of summary.data?.snipers; track sniper.userId) {
            <span>
              {{ sniper.userName }} · {{ sniper.sniperCount }}
            </span>
          }
        </div>
      </section>
    }

    @if (summary.data?.jokerHighlights?.length) {
      <section>
        <h2>Jokers destacados</h2>
        <p>{{ summary.data?.jokerHighlights?.join(", ") }}</p>
      </section>
    }

    @if (summary.data?.matches?.length) {
      <section>
        <h2>Resultados</h2>
        <div class="results">
          @for (match of summary.data?.matches; track $index) {
            <div>
              <span>{{ match.homeTeam }}</span>
              <b>{{ match.homeGoals }} - {{ match.awayGoals }}</b>
              <span>{{ match.awayTeam }}</span>
            </div>
          }
        </div>
      </section>
    }
  </div>

  <footer>
    <button mat-flat-button type="button" (click)="close()">Cerrar</button>
  </footer>
</article>
